import {useMemo, useState} from "react";
import {TagCategoryEntity} from "@ots-frontend/ots-data";
import {useDebouncedValue} from "@mantine/hooks";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";

export type UseTagCategoryDataTableFilterProps = Omit<UseDataTableFilterProps<TagCategoryEntity>, 'filterConfig'>

export function useTagCategoryDataTableFilter(props: UseTagCategoryDataTableFilterProps): UseDataTableFilterResult<TagCategoryEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [labelQuery, setLabelQuery] = useState<string | undefined>(undefined);
  const [labelDebouncedQuery] = useDebouncedValue(labelQuery, 200);

  const filterConfig: DataTableFilterConfig<TagCategoryEntity> = useMemo(() => {
    return {
      "label": {
        setQuery: setLabelQuery,
        query: labelQuery,
        debouncedQuery: labelDebouncedQuery,
        filter: ({label}, query) => !label || !label.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    labelQuery,
    labelDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
